export default __webpack_public_path__ + "static/media/cont-logo.81eb4596.png";